<template>
  <div id="app" :class="$store.state.isPc ? 'app-pc' : ''">
    <div class="nav-bar " v-if="$store.state.isPc"
         :class="$store.state.isAlpha ? 'BFFFA45' : 'BFFF'">
      <div class="w100 flexHBC">
        <img src="../src/assets/images/icon_logo.svg" class="nav-bar-logo"
             @click="navHomeClick('/',0)">
        <div class="nav-menu flexHC">
          <div class="nav-menu-item" v-for="(item,index) in menu">
            <div class="nav-menu-item  flexHC2" @mouseenter="moreEnter(index)"
                 @mouseleave="moreLeave(index)"
                 :class="index == $store.state.currentIndex  ? 'item-select' : 'item-default'"
                 @click="navClick(item.path,index,item.query,item.children)">{{item.title}}
            </div>
            <div class="nav-children flexVC" :style="item.width" v-show="item.isShow"
                 @mouseenter="moreEnter(index)" @mouseleave="moreLeave(index)">
              <div class="nav-children-item " v-for="(child, childIndex) in item.children"
                   :class="index == currentClickIndex && $store.state.childIndex == childIndex ? 'item-select' : 'item-default'"
              >
                <a @click="navChild(child.path,child.query,index,childIndex)"
                   class="container flexHC">{{child.name}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-bar-mobile flexVC" v-if="!$store.state.isPc"
         :style="isExpand ? 'height: 100%;' : 'height: 1.2rem;'"
         :class="$store.state.isAlpha && !isExpand ? 'BFFFA45-m' : 'Bf0f2f5-m'">
      <div class="mobile-bar-width flexHBC " style="height: 1.2rem;">
        <img src="../src/assets/images/icon_logo.svg" class="nav-bar-logo-mobile"
             @click="navHomeClick('/',0)">
        <img src="../src/assets/images/icon_mobile_close.png" class="nav-bar-close-mobile"
             v-show="isExpand"
             :class="isExpand ? 'rotate-menu' : ''"
             @click="expandCloseClick">
        <img src="../src/assets/images/icon_mobile_menu.png" class="nav-bar-menu-mobile"
             v-show="!isExpand"
             :class="!isExpand ? 'rotate-close' : ''"
             @click="expandClick">
      </div>
      <div class="nav-bar-mobile-item flexVC" v-for="(item,index) in menuM" v-show="isExpand">
        <div class="w100m flexHBC" style="height: 0.96rem;"
             @click="navClickm(item.path,index,item.query,item.children)">
          <div class="nav-bar-mobile-item-title">{{item.title}}</div>
          <div></div>
        </div>
        <div class="nav-bar-mobile-item-child flexHC2" v-for="(child, childIndex) in item.children"
             v-show="item.isShow"
             :style="childIndex == item.children.length - 1 ? '' : 'border-bottom: 0.02rem solid rgba(0, 0, 0, .06);'"
             @click="navChildClickm(child.path,child.query,index,childIndex)">
          <div class="nav-bar-mobile-item-subtitle">{{child.name}}</div>
        </div>
      </div>
    </div>
    <div class="box-c" v-if="$store.state.isPc || !isAndroid">
<!--      <Scroll>-->
        <router-view/>
<!--      </Scroll>-->
    </div>
    <div class="box-c" v-if="!$store.state.isPc && isAndroid">
      <Scroll>
        <router-view/>
      </Scroll>
    </div>
  </div>
</template>

<script>
  import Scroll from '@/components/Scroll';

  export default {
    name: 'App',
    data() {
      return {
        currentIndex: 0,
        currentIndexTemp: 0,
        currentClickIndex: 0,
        currentIndexChild: -1,
        isExpand: false,
        menu: [{
          title: '首页',
          path: '/',
          index: 0,
          isShow: false,
        }, {
          title: '学院',
          path: '/college',
          query: {
            index: 1
          },
          index: 1,
          isShow: false,
          width: 'width: 130px;',
          children: [{
            name: '百日计划',
            path: '/college',
            query: {
              index: 1
            },
          }, {
            name: '线上内容',
            path: '/college',
            query: {
              index: 2
            },
          }, {
            name: '学院讲者',
            path: '/college',
            query: {
              index: 3
            },
          }, {
            name: '优秀学员',
            path: '/college',
            query: {
              index: 4
            },
          },],
        }, {
          title: '社群',
          path: '/association',
          query: {
            index: 1
          },
          index: 2,
          isShow: false,
          width: 'width: 140px;',
          children: [{
            name: '趁早读书会',
            path: '/association',
            query: {
              index: 1
            },
          }, {
            name: '趁早跑团',
            path: '/associationRunning',
            query: {
              index: 2
            },
          }],
        }, {
          title: '活动',
          path: '/activity',
          query: {
            index: 1
          },
          isShow: false,
          index: 3,
          width: 'width: 240px;',
          children: [{
            name: '趁早PARTY',
            path: '/activity',
            query: {
              index: 1
            },
          }, {
            name: 'SHAPEGIRL马甲线大赛',
            path: '/activity',
            query: {
              index: 2
            },
          }, {
            name: '趁早巡展',
            path: '/activity',
            query: {
              index: 3
            },
          }, {
            name: '趁早话剧',
            path: '/activity',
            query: {
              index: 4
            },
          }],
        }, {
          title: '周边',
          path: '/periphery',
          query: {
            index: 1
          },
          isShow: false,
          index: 4,
          width: 'width: 130px;',
          children: [{
            name: '趁早文创',
            path: '/periphery',
            query: {
              index: 1
            },
          }, {
            name: '趁早服饰',
            path: '/periphery',
            query: {
              index: 2
            },
          }],
        }, {
          title: '关于',
          path: '/about',
          query: {
            index: 1
          },
          isShow: false,
          isPC: true,
          index: 5,
          width: 'width: 140px;',
          children: [{
            name: '关于趁早',
            path: '/about',
            query: {
              index: 1
            },
          }, {
            name: '创始人介绍',
            path: '/founder',
            query: {
              index: 2
            },
          }, {
            name: '商务合作',
            path: '/aboutBusiness',
            query: {
              index: 3
            },
          }, {
            name: '加入我们',
            path: '/aboutJoinUs',
            query: {
              index: 4
            },
          },
            // {
            // name: '用户协议',
            // path: '/agreement',
            // query: {
            //   index: 5
            // },
            // }
          ],
        }],
        menuM: [{
          title: '首页',
          path: '/',
          index: 0,
          isShow: false,
        }, {
          title: '学院',
          path: '',
          query: {
            index: 1
          },
          index: 1,
          isShow: false,
          width: 'width: 130px;',
          children: [{
            name: '百日计划',
            path: '/college',
            query: {
              index: 1
            },
          }, {
            name: '线上内容',
            path: '/college',
            query: {
              index: 2
            },
          }, {
            name: '学院讲者',
            path: '/college',
            query: {
              index: 3
            },
          }, {
            name: '优秀学员',
            path: '/college',
            query: {
              index: 4
            },
          },],
        }, {
          title: '社群',
          path: '',
          query: {
            index: 1
          },
          index: 2,
          isShow: false,
          width: 'width: 140px;',
          children: [{
            name: '趁早读书会',
            path: '/association',
            query: {
              index: 1
            },
          }, {
            name: '趁早跑团',
            path: '/associationRunning',
            query: {
              index: 2
            },
          }],
        }, {
          title: '活动',
          path: '',
          query: {
            index: 1
          },
          isShow: false,
          index: 3,
          width: 'width: 240px;',
          children: [{
            name: '趁早PARTY',
            path: '/activity',
            query: {
              index: 1
            },
          }, {
            name: 'SHAPEGIRL马甲线大赛',
            path: '/activity',
            query: {
              index: 2
            },
          }, {
            name: '趁早巡展',
            path: '/activity',
            query: {
              index: 3
            },
          }, {
            name: '趁早话剧',
            path: '/activity',
            query: {
              index: 4
            },
          }],
        }, {
          title: '周边',
          path: '',
          query: {
            index: 1
          },
          isShow: false,
          index: 4,
          width: 'width: 130px;',
          children: [{
            name: '趁早文创',
            path: '/periphery',
            query: {
              index: 1
            },
          }, {
            name: '趁早服饰',
            path: '/periphery',
            query: {
              index: 2
            },
          }],
        }, {
          title: '关于',
          path: '',
          query: {
            index: 1
          },
          isShow: false,
          isPC: true,
          index: 5,
          width: 'width: 140px;',
          children: [{
            name: '关于趁早',
            path: '/about',
            query: {
              index: 1
            },
          }, {
            name: '创始人介绍',
            path: '/founder',
            query: {
              index: 2
            },
          }, {
            name: '商务合作',
            path: '/aboutBusiness',
            query: {
              index: 3
            },
          }, {
            name: '加入我们',
            path: '/aboutJoinUs',
            query: {
              index: 4
            },
          },
            // {
            // name: '用户协议',
            // path: '/agreement',
            // query: {
            //   index: 5
            // },
            // }
          ],
        }],
        isAndroid: false,
      }
    },

    components: {
      Scroll
    },
    mounted() {
      var u = navigator.userAgent;　　// 获取当前设备信息
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        this.isAndroid = true
      } else {
        this.isAndroid = false
      }
      this.browserRedirect()
      this.menu.forEach((item, index) => {
        if (item.children) {
          item.children.forEach((child, childIndex) => {
            if (child.path == this.$route.path) {
              this.currentIndex = index
              this.currentIndexTemp = index
              this.currentClickIndex = index
              this.currentIndexChild = this.$route.query.index - 1
              this.$store.commit('edit', this.$route.query.index - 1)
              this.$store.commit('editIndex', index)
            }
          })
        } else {
          if (item.path == this.$route.path) {
            this.currentIndex = index
            this.currentIndexTemp = index
            this.currentClickIndex = index
            this.currentIndexChild = -1
            this.$store.commit('edit', -1)
            this.$store.commit('editIndex', index)
          }
        }
      })
      console.log('this.$route.path----', this.$route.path)
      console.log('this.$route.this.$route.query.index----', this.$route.query.index)
    },

    methods: {

      fnResize() {
        var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
        if (deviceWidth >= 750) {
          deviceWidth = 750;
        }
        if (deviceWidth <= 320) {
          deviceWidth = 320;
        }
        console.log('3333333333333333ssssssssssss33333333333333333333')
        document.documentElement.style.fontSize = (deviceWidth / 7.5) + 'px';
      },
      expandClick() {
        this.isExpand = true
      },
      expandCloseClick() {
        this.isExpand = false
      },
      browserRedirect() {
        var sUserAgent = navigator.userAgent.toLowerCase()
        // var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
        var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
        var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
        var bIsAndroid = sUserAgent.match(/android/i) == 'android'
        var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
        var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
        if (bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
          this.isPC = false
          this.fnResize()
          this.$store.commit('isPCEdit', false)
        } else {
          this.isPC = true
          console.log('pc')
          this.$store.commit('isPCEdit', true)
        }
      },
      navHomeClick(path, index) {
        this.currentIndex = index
        this.currentIndexTemp = index
        this.currentClickIndex = index
        this.currentIndexChild = -1
        this.$store.commit('edit', -1)
        this.$store.commit('slideEdit', true)
        this.$store.commit('editIndex', index)
        this.$router.push({
          path: path,
          query: {}
        })
        // window.location.reload()
      },
      navClick(path, index, query, children) {
        this.currentIndex = index
        this.currentIndexTemp = index
        this.currentClickIndex = index
        this.$store.commit('editIndex', index)
        this.$store.commit('slideEdit', true)
        if (typeof (children) == 'undefined') {
          this.$store.commit('edit', -1)
          this.currentIndexChild = -1
        } else {
          this.$store.commit('edit', 0)
          this.currentIndexChild = 0
        }
        if (typeof (query) == 'undefined') {
          query = {}
        }
        this.$router.push({
          path: path,
          query: query
        })
      },
      navChild(path, query, index, child) {
        this.currentIndexChild = child
        this.currentClickIndex = index
        this.currentIndex = index
        this.currentIndexTemp = index
        this.$store.commit('edit', child)
        this.$store.commit('editIndex', index)
        this.$store.commit('slideEdit', true)
        console.log(path)
        this.menu[index].isShow = false
        this.$router.push({
          path: path,
          query: query
        })
      },
      navClickm(path, index, query, children) {
        if (path) {
          this.currentIndex = index
          this.currentIndexTemp = index
          this.currentClickIndex = index
          this.$store.commit('editIndex', index)
          this.$store.commit('slideEdit', true)
          if (typeof (children) == 'undefined') {
            this.$store.commit('edit', -1)
            this.currentIndexChild = -1
          } else {
            this.$store.commit('edit', 0)
            this.currentIndexChild = 0
          }
          if (typeof (query) == 'undefined') {
            query = {}
          }
          this.$router.push({
            path: path,
            query: query
          })
          this.isExpand = false
        } else {
          this.menuM.forEach(item => {
            item.isShow = false
          })
          this.menuM[index].isShow = true
        }
      },
      navChildClickm(path, query, index, child) {
        if (path) {
          this.currentIndexChild = child
          this.currentClickIndex = index
          this.currentIndex = index
          this.currentIndexTemp = index
          this.$store.commit('edit', child)
          this.$store.commit('editIndex', index)
          this.$store.commit('slideEdit', true)
          console.log('asdasdqqq----', query)
          this.$router.push({
            path: path,
            query: query
          })
        } else {
          this.menuM.forEach(item => {
            item.isShow = false
          })
          this.menuM[index].isShow = true
        }
        this.isExpand = false
      },
      moreEnter(index) {
        this.menu[index].isShow = true
        this.currentIndex = index
      },
      moreLeave(index) {
        this.menu[index].isShow = false
        this.currentIndex = this.currentIndexTemp
      },
    },
  }
</script>

<style>
  @import "assets/fonts/font.css";
  @import "assets/public/swiper-bundle.css";

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    position: relative;
    width: 100%;

    height: 100%;
    margin: 0 auto;
  }

  .app-pc {
    min-width: 1000px;
    max-width: 2200px;
  }

  .nav-bar {
    width: 100%;
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }

  .BFFF {
    background: #FFFFFF;
  }

  .BFFFA45 {
    background: rgba(255, 255, 255, .45);
  }

  .nav-children {
    height: auto;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid rgba(0, 0, 0, 0.04);
    position: absolute;
    left: -1px;
    top: 59px;
  }

  .nav-children-item {
    width: calc(100% - 60px);
    height: 56px;
    float: left;
    padding-left: 20px;
    padding-right: 40px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    background: #FFFFFF;
  }

  .nav-children-item:hover {
    background: #D70050;
    color: #ffffff;
  }

  .BD70050 {
    background: #D70050;
    color: #ffffff;
  }

  .nav-bar-logo {
    width: 50px;
    height: 24px;
    margin-left: 7.71vw;
    cursor: pointer;
  }

  .nav-menu {
    width: auto;
    height: 60px;
    margin-right: 7.71vw;
  }

  .nav-menu-item {
    width: 68px;
    height: 60px;
    cursor: pointer;
    position: relative;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    z-index: 9999;
  }

  .nav-menu-item:hover {
    width: 68px;
    height: 60px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background: #D70050;
    z-index: 9999;
  }

  .item-select {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background: #D70050;
  }

  .item-default {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, .85);
    /*background: #FFFFFF;*/
  }


  .nav-bar-mobile {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    overflow: scroll;
    /*padding-bottom: 1rem;*/
  }

  .mobile-bar-width {
    width: calc(100% - 12.8vw);
  }

  .nav-bar-mobile-item {
    width: calc(100% - 12.8vw);
    border-bottom: 0.01rem solid rgba(0, 0, 0, .06);
    border-top: 0.02rem solid rgba(0, 0, 0, .06);
  }

  .nav-bar-mobile-item-child {
    width: calc(100% - 0.48rem);
    height: 0.92rem;
  }

  .nav-bar-mobile-item-title {
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .nav-bar-mobile-item-subtitle {
    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
  }


  .nav-bar-logo-mobile {
    width: 0.66rem;
    height: 0.32rem;
    cursor: pointer;
  }

  .nav-bar-close-mobile {
    width: 0.32rem;
    height: 0.32rem;
    cursor: pointer;
  }

  .nav-bar-menu-mobile {
    width: 0.40rem;
    height: 0.40rem;
    cursor: pointer;
  }

  .rotate-menu {
    animation-name: rotate;
    animation-duration: 0.2s;
    /*animation-delay: 0.2s;*/
    animation-fill-mode: forwards;
  }

  .rotate-close {
    animation-name: rotate90;
    animation-duration: 0.2s;
    /*animation-delay: 0.2s;*/
    animation-fill-mode: forwards;
  }


  @keyframes rotate {
    0% {
      transform: rotate(-90deg);
    }
    100% {
      transform: rotate(0deg);
      /*transform: scale(1);*/
    }
  }

  @keyframes rotate90 {
    0% {
      transform: rotate(90deg);
    }
    100% {
      transform: rotate(0deg);
      /*transform: scale(1);*/
    }
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    height: 100%;
    line-height: 1;
    font-size: 16px;
    width: 100%;
  }

  .BigBox {
    height: 100%;
    overflow: hidden;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  * {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  /*
  KISSY CSS Reset
  理念：1. reset 的目的不是清除浏览器的默认样式，这仅是部分工作。清除和重置是紧密不可分的。
  2. reset 的目的不是让默认样式在所有浏览器下一致，而是减少默认样式有可能带来的问题。
  3. reset 期望提供一套普适通用的基础样式。但没有银弹，推荐根据具体需求，裁剪和修改后再使用。
  特色：1. 适应中文；2. 基于主流浏览器。
  维护：玉伯<lifesinger@gmail.com>, 正淳<ragecarrier@gmail.com>
   */

  /** 清除内外边距 **/
  body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
  dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
  pre, /* text formatting elements 文本格式元素 */
  form, fieldset, legend, button, input, textarea, /* form elements 表单元素 */
  th, td /* table elements 表格元素 */
  {
    margin: 0;
    padding: 0;
  }


  /** 设置默认字体 **/
  body,
  button, input, select, textarea /* for ie */
  {
    font: 12px/1.5 tahoma, arial, \5b8b\4f53, sans-serif;
  }

  /*html, body, #app, .wx-pages {*/
  /*  padding: 0;*/
  /*  margin: 0;*/
  /*  height: 100%;*/
  /*  overflow: hidden;*/
  /*  -webkit-overflow-scrolling: touch;*/
  /*}*/

  .wx-pages {
    padding: 0;
    margin: 0;
    height: 100%;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
  }


  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
  }

  address, cite, dfn, em, var {
    font-style: normal;
  }

  /* 将斜体扶正 */
  code, kbd, pre, samp {
    font-family: courier new, courier, monospace;
  }

  /* 统一等宽字体 */
  small {
    font-size: 12px;
  }

  /* 小于 12px 的中文很难阅读，让 small 正常化 */

  /** 重置列表元素 **/
  ul, ol {
    list-style: none;
  }

  /** 重置文本格式元素 **/
  a {
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }


  /** 重置表单元素 **/
  legend {
    color: #000;
  }

  /* for ie6 */
  fieldset, img {
    border: 0;
  }

  /* img 搭车：让链接里的 img 无边框 */
  button, input, select, textarea {
    font-size: 100%;
  }

  button {
    background: none;
    border: none;
  }

  /* 使得表单元素在 ie 下能继承字体大小 */
  /* 注：optgroup 无法扶正 */
  /** 重置表格元素 **/
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /*包含以下四种的链接*/
  a {
    text-decoration: none;
  }

  /*正常的未被访问过的链接*/
  a:link {
    text-decoration: none;
  }

  /*已经访问过的链接*/
  a:visited {
    text-decoration: none;
  }

  /*鼠标划过(停留)的链接*/
  a:hover {
    text-decoration: none;
  }

  /* 正在点击的链接*/
  a:active {
    text-decoration: none;
  }

  /*  公共样式 */

  .flexH {
    display: flex;
    justify-content: flex-start;
  }

  .flexHC {
    display: flex;
    align-items: center;
  }

  .flexHC2 {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flexHBLine {
    display: flex;
    align-items: baseline;
  }

  .flexHBC {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flexV {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .flexVC {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .flexVC2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .flexVC3 {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .flexWrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .flexWrap2 {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .fontE1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .marL5 {
    margin-left: 5px;
  }

  .marL8 {
    margin-left: 8px;
  }

  .marL10 {
    margin-left: 10px;
  }

  .marL15 {
    margin-left: 15px;
  }

  .marL20 {
    margin-left: 20px;
  }

  .marL25 {
    margin-left: 25px;
  }

  .marL30 {
    margin-left: 30px;
  }

  .marL32 {
    margin-left: 32px;
  }

  .marL35 {
    margin-left: 35px;
  }

  .marL40 {
    margin-left: 40px;
  }

  .marL45 {
    margin-left: 45px;
  }

  .marL50 {
    margin-left: 50px;
  }

  .marR5 {
    margin-right: 5px;
  }

  .marR10 {
    margin-right: 10px;
  }

  .marR15 {
    margin-right: 15px;
  }

  .marR20 {
    margin-right: 20px;
  }

  .marR25 {
    margin-right: 25px;
  }

  .marR30 {
    margin-right: 30px;
  }

  .marR32 {
    margin-right: 32px;
  }

  .marR35 {
    margin-right: 35px;
  }

  .marR40 {
    margin-right: 40px;
  }

  .marR45 {
    margin-right: 45px;
  }

  .marR50 {
    margin-right: 50px;
  }

  .marT5 {
    margin-top: 5px;
  }

  .marT10 {
    margin-top: 10px;
  }

  .marT15 {
    margin-top: 15px;
  }

  .marT20 {
    margin-top: 20px;
  }

  .marT25 {
    margin-top: 25px;
  }

  .marT30 {
    margin-top: 30px;
  }

  .marT32 {
    margin-top: 32px;
  }

  .marT35 {
    margin-top: 35px;
  }

  .marT40 {
    margin-top: 40px;
  }

  .marT45 {
    margin-top: 45px;
  }

  .marT50 {
    margin-top: 50px;
  }

  .marB5 {
    margin-bottom: 5px;
  }

  .marB10 {
    margin-bottom: 10px;
  }

  .marB15 {
    margin-bottom: 15px;
  }

  .marB20 {
    margin-bottom: 20px;
  }

  .marB25 {
    margin-bottom: 25px;
  }

  .marB30 {
    margin-bottom: 30px;
  }

  .marB32 {
    margin-bottom: 32px;
  }

  .marB35 {
    margin-bottom: 35px;
  }

  .marB40 {
    margin-bottom: 40px;
  }

  .marB45 {
    margin-bottom: 45px;
  }

  .marB50 {
    margin-bottom: 50px;
  }

  .container {
    width: 100%;
    max-width: 2400px;
    height: 100%;
    overflow: hidden;
  }

  .container-m {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #f0f2f5;
  }

  .box-c {
    width: 100%;
    height: 100%;
  }

  .pR {
    position: relative;
  }

  .w100 {
    width: 100%;
    max-width: 2200px;
  }

  .w100m {
    width: 100%;
  }

  .C000 {
    color: #000000;
  }

  .CFFF {
    color: #FFFFFF;
  }

  .Bf0f2f5 {
    background: #f0f2f5;
  }


  .Bf0f2f5-m {
    position: fixed;
    top: 0;
    left: 0;
    background: #f0f2f5;
  }


  .BFFFA45-m {
    background: rgba(255, 255, 255, 0);
    position: absolute;
    top: 0;
    left: 0;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue